module.exports = __webpack_public_path__ + "4fa5d995e4cffcce902337414edc6fdc.svg";